<template>
  <WadMenu
    :base-url="baseUrl"
    :api-base-url="apiBaseUrl"
    :cdn-base-url="cdnBaseUrl"
    :labs-base-url="labsBaseUrl"
    :language="language"
    :user="isAuthenticated ? user : undefined"
    :theme="currentTheme"
    @theme-change="onThemeChange"
    @logout="onLogout"
  />
</template>

<script setup lang="ts">
import WadMenu from './menu/WadMenu.vue'
import type { ThemeOption } from './menu/types'

const { $theme } = useNuxtApp()
const rc = useRuntimeConfig()
const route = useRoute()
const { user, isAuthenticated } = useAuthUser()
const { signOut } = useAuth()

const baseUrl = useSelfBaseUrl()
const apiBaseUrl = (rc.public.wadApiBaseUrl as string) || ''
const cdnBaseUrl = (rc.public.wadCdnRoot as string) || ''
const labsBaseUrl = (rc.public.wadLabsBaseUrl as string) || ''
const language = computed(() => (route.params.lang as string | undefined) || 'en')

const currentTheme = computed<ThemeOption>(() => $theme?.currentOption.value as ThemeOption)

function onThemeChange(option: ThemeOption) {
  $theme.set(option)
}

async function onLogout() {
  await signOut({ redirect: false })
  const middleware = route.meta.middleware
  const protectedMiddlewares = ['require-user', 'require-developer', 'require-admin']
  const isProtected = Array.isArray(middleware)
    ? middleware.some(m => protectedMiddlewares.includes(m as string))
    : protectedMiddlewares.includes(middleware as string)
  if (isProtected) {
    window.location.href = baseUrl
  } else {
    window.location.reload()
  }
}
</script>
